import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaPuzzlePiece, FaUserGraduate, FaSignOutAlt } from "react-icons/fa";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const closeMenu = () => setMenuOpen(false);

  const handleLogout = () => {
    closeMenu();
    navigate("/login");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark shadow-lg">
      {/* Gradient background */}
      <div
        className="w-100 h-100 position-absolute top-0 start-0"
        style={{
          background:
            "linear-gradient(90deg, #ff9a9e, #fad0c4, #fbc2eb, #a1c4fd)",
          zIndex: -1,
        }}
      />

      <div className="container-fluid">
        {/* Logo */}
        <Link
          className="navbar-brand fw-bold fs-2 text-dark text-decoration-none"
          to="/"
          onClick={closeMenu}
        >
          🦄 KiddoLearn
        </Link>

        {/* Hamburger toggle */}
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/* Collapsible menu */}
        <div
          className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-2 align-items-center">
            {/* Dashboard */}
            <li className="nav-item">
              <Link
                className="nav-link fw-bold btn btn-warning rounded-pill px-3 py-2 text-dark"
                to="/dashboard"
                onClick={closeMenu}
              >
                <FaUserGraduate className="me-1" /> Dashboard
              </Link>
            </li>

            {/* Games dropdown — hover on desktop, click on mobile */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link fw-bold btn btn-success rounded-pill px-5 py-2 text-dark dropdown-toggle"
                to="#"
                id="gamesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FaPuzzlePiece className="me-1" /> Games
              </Link>

              <ul
                className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3 p-2"
                aria-labelledby="gamesDropdown"
                style={{ minWidth: "220px" }}
              >
                <li>
                  <Link
                    className="dropdown-item fw-bold text-dark py-2"
                    to="/alphabet-puzzle"
                    onClick={closeMenu}
                  >
                    🎲 Alphabet Puzzle
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fw-bold text-dark py-2"
                    to="/balloon-letter-pop"
                    onClick={closeMenu}
                  >
                    🎈 Balloon Letter Pop-Up
                  </Link>
                </li>
              </ul>
            </li>

            {/* Logout */}
            <li className="nav-item">
              {/* <button
                className="nav-link fw-bold btn btn-danger rounded-pill px-3 py-2 text-dark"
                onClick={handleLogout}
                aria-label="Logout"
                title="Logout"
              >
                <FaSignOutAlt />
              </button> */}
            </li>
          </ul>
        </div>
      </div>

      {/* Scoped styles */}
      <style>{`
        html, body { overflow-x: hidden; }
        .navbar-brand { text-shadow: 0 0 2px #fff; }

        /* Desktop: open on hover, animate */
        @media (min-width: 992px) {
          .navbar-nav .dropdown:hover > .dropdown-menu {
            display: block;
            margin-top: 0;
            animation: fadeInSlide 0.25s ease-out;
          }
          @keyframes fadeInSlide {
            from { opacity: 0; transform: translateY(-8px); }
            to   { opacity: 1; transform: translateY(0);   }
          }
        }

        /* Mobile: keep static, full-width-ish */
        @media (max-width: 991.98px) {
          .navbar .dropdown-menu {
            position: static !important;
            transform: none !important;
            width: 100%;
            max-width: 92vw;
            margin-top: 0.5rem;
          }
        }

        .dropdown-item:hover,
        .dropdown-item:focus {
          background-color: #ffe0f7 !important;
          transform: scale(1.03);
          transition: all 0.2s ease-in-out;
        }

        .btn:focus-visible,
        .nav-link:focus-visible {
          outline: 3px solid #6f42c1;
          outline-offset: 2px;
        }

        @media (max-width: 400px) {
          .btn { padding-left: 0.75rem !important; padding-right: 0.75rem !important; }
        }
      `}</style>
    </nav>
  );
}